import { render, staticRenderFns } from "./TextArea.vue?vue&type=template&id=62ca4e6f&scoped=true&"
import script from "./TextArea.vue?vue&type=script&lang=ts&"
export * from "./TextArea.vue?vue&type=script&lang=ts&"
import style0 from "./TextArea.vue?vue&type=style&index=0&id=62ca4e6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ca4e6f",
  null
  
)

export default component.exports